import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getToken } from "../../utils/utils";

/* LISTAGEM */
export const fetchCollaborator = createAsyncThunk(
  "fetchCollaborator",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL +
      "/controller/collaborator/list.php?page=" +
      data.page +
      "&limit=" +
      data.limit;
    const authorization = getToken();
    const options = {
      method: "GET",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      data,
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

/* BUSCA */
export const fetchCollaboratorSearch = createAsyncThunk(
  "fetchCollaboratorSearch",
  async (query, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL +
      `/controller/collaborator/search.php?search=${query}`;
    const authorization = getToken();
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data.collaborator;
        } else {
          return "Error";
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

/* DETALHES PARA EDIÇÃO */
export const fetchCollaboratorEdit = createAsyncThunk(
  "fetchCollaboratorEdit",
  async ({ id }, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL +
      `/controller/collaborator/details.php?id=${id}`;
    const authorization = getToken();
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data.collaborator[0];
        } else {
          return "Error";
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

/* CRIAÇÃO */
export const saveCollaborator = createAsyncThunk(
  "saveCollaborator",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL + "/controller/collaborator/create.php";
    const authorization = getToken();
    const options = {
      method: "post",
      headers: {
        Authorization: "Bearer " + authorization,
        "Content-Type": "multipart/form-data",
      },
      url,
      data: data,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          if (result.data.collaborator) return result.data.collaborator;
          else return result.data.message;
        } else {
          return "Error";
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

/* ATUALIZAÇÃO */
export const editCollaborator = createAsyncThunk(
  "editCollaborator",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL + "/controller/collaborator/update.php";
    const authorization = getToken();
    const options = {
      method: "post",
      headers: {
        Authorization: "Bearer " + authorization,
        "Content-Type": "multipart/form-data",
      },
      url,
      data: data,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          if (result.data.collaborator) return result.data.collaborator;
          else return result.data.message;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

/* EXCLUSÃO */
export const deleteCollaborator = createAsyncThunk(
  "deleteCollaborator",
  async (id, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL +
      `/controller/collaborator/delete.php?id=${id}`;
    const authorization = getToken();
    const options = {
      method: "delete",
      headers: { Authorization: "Bearer " + authorization },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        return result.status;
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);
